import { render } from "./DialogHeader.vue?vue&type=template&id=0388a414&ts=true"
import script from "./DialogHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogHeader.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/dialog/DialogHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0388a414"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0388a414', __exports__)) {
    api.reload('0388a414', __exports__)
  }
  
  module.hot.accept("./DialogHeader.vue?vue&type=template&id=0388a414&ts=true", () => {
    api.rerender('0388a414', render)
  })

}


export default __exports__